import React, { useEffect, useState } from 'react'
import GenericFormHeaderComponent from '../../../genericComponents/forms/GenericFormHeaderComponent'
import Icons from '../../../assets/icons'
import { useDispatch, useSelector } from 'react-redux'
import { dispatchHandler } from '../../../helper/apiHelperFunctions'
import EscalationMatrixSkeleton from './EscalationMatrixSkeleton'
import CopyText from '../../helperComponents/CopyText'
import LanguageTranslator from '../../../locals/LanguageTranslator'
import { ExternalLink, ScrollText } from 'lucide-react'

const EscalationMatrixModal = (props) => {
    const administrationStore = useSelector(state => state.administrationStore)
    const dispatch = useDispatch()

    const [supportData, setSupportData] = useState({
        name: '',
        email: '',
        phoneNo: ''
    })

    useEffect(() => {
        dispatchHandler(dispatch, 'getGeneralSettingRequest')
    }, [])

    useEffect(() => {
        if (administrationStore?.getGeneralSettingData?.isSuccess) {
            setSupportData({
                name: administrationStore?.getGeneralSettingData?.data?.resource?.data?.accManagerName,
                email: administrationStore?.getGeneralSettingData?.data?.resource?.data?.accManagerEmail,
                phoneNo: administrationStore?.getGeneralSettingData?.data?.resource?.data?.accManagerContact
            })
        }
    }, [administrationStore?.getGeneralSettingData?.isSuccess])


    const cardsData = [
        {
            level: 'LEVEL 1',
            levelColor: 'h1-blue',
            label: 'Technical Support',
            description: <>Please coordinate with the <span className='font-bold'>mentioned support person</span> in the ticket from our team.</>,
        },
        {
            level: 'LEVEL 2',
            levelColor: 'h1-orange',
            label: 'Support Manager',
            data: [
                {
                    icon: <Icons.ProfileFaceIcon />,
                    label: 'Support Manager Name',
                    value: 'Krishang Saxena'
                },
                {
                    icon: <Icons.EmailReport />,
                    label: 'Support Manager Email',
                    value: <> <a href={`mailto:${'krishang.saxena@supplymint.com'}`} target='_blank' rel="noreferrer" >krishang.saxena@supplymint.com</a>
                        <CopyText color="#67768E" textToCopy={'krishang.saxena@supplymint.com'} />
                    </>
                }
            ]
        },
        {
            level: 'LEVEL 3',
            levelColor: 'h1-orange-dark',
            label: 'Account Manager [KAM]',
            data: [
                {
                    icon: <Icons.ProfileFaceIcon />,
                    label: 'KAM Name',
                    value: supportData.name || ''
                },
                {
                    icon: <Icons.EmailReport />,
                    label: 'KAM Email',
                    value: <> <a href={`mailto:${supportData.email}`} target='_blank' rel="noreferrer" >{supportData.email}</a>
                        <CopyText color="#67768E" textToCopy={supportData?.email} />
                    </>
                },
                {
                    icon: <Icons.PhoneIcon />,
                    label: 'Phone Number',
                    value: supportData.phoneNo || ''
                }
            ]
        },
        {
            level: 'LEVEL 4',
            levelColor: 'h1-red',
            label: 'Executive Support',
            data: [
                {
                    icon: <Icons.ProfileFaceIcon />,
                    label: 'Executive Name',
                    value: 'Soni Singh'
                },
                {
                    icon: <Icons.EmailReport />,
                    label: 'Executive Email',
                    value: <>
                        <a href={`mailto:${'soni@supplymint.com'}`} target='_blank' rel="noreferrer" >soni@supplymint.com</a>
                        <CopyText color="#67768E" textToCopy={'soni@supplymint.com'} />
                    </>
                }
            ]
        }
    ]

    return (<div className='escalation-matrix'>
        <GenericFormHeaderComponent
            label={() => (
                <div className='mhs-left flex items-center'>
                    <LanguageTranslator tag="h4">{"Escalation Matrix"}</LanguageTranslator>
                    <span className='inline-block text-[12px] font-semibold px-[10px] py-[2px] border-[1.5px] border-[#5D5FEF] rounded-[20px] ml-[10px] text-[#5D5FEF] align-middle'>Standard Plan</span>
                </div>
            )}

            closeModal={props.closeModal}
        />

        {/* cards display */}
        <div className='em-body' >
            {administrationStore.getGeneralSettingData?.isLoading ? <EscalationMatrixSkeleton /> :
                <>
                    <div className='flex gap-4 items-stretch'>
                        {cardsData.map((card, index) => {
                            return <div className='flex-1 min-w-0 px-[15px] py-[10px] border border-[#DAE4EE] rounded-[10px] transition-all duration-200 hover:border-[#B8C4D0] hover:-translate-y-[2px] cursor-default' key={index}>
                                <LanguageTranslator tag='h1' className={`${card.levelColor} rounded-[3px]`}>{card.level}</LanguageTranslator>
                                <LanguageTranslator tag='h2'>{card.label}</LanguageTranslator>
                                {card.description ? (
                                    <div className='pt-[15px]'>
                                        <p className='text-[#333] text-[13px] font-medium leading-[1.6] m-0'>{card.description}</p>
                                    </div>
                                ) : (
                                    <div className='pt-5'>
                                        {card.data?.map((item, idx) => {
                                            return <div className='embcd-sec' key={idx}>
                                                <div className='pr-[10px] [&_svg_path]:fill-black [&_svg_g_path]:fill-none [&_svg_g_path]:stroke-black'>
                                                    {item.icon}
                                                </div>
                                                <div className='grid'>
                                                    {/* <LanguageTranslator tag='label'>{item.label}</LanguageTranslator> */}
                                                    <p className='break-all'>{item.value}</p>
                                                </div>
                                            </div>
                                        })
                                        }
                                    </div>
                                )}
                            </div>
                        })}
                    </div>

                    {/* Support SLA Policy */}
                    <div className='flex items-center gap-2 py-[5px] [&_svg]:w-[18px] [&_svg]:h-[18px]'>
                        <ScrollText color='#5D5FEF' />
                        <a href='https://www.supplymint.com/legal/support-sla-policy' target='_blank' rel="noreferrer" className='text-[#5D5FEF] text-[13px] font-semibold underline flex items-center'>Support SLA Policy <ExternalLink color='#5D5FEF' size={10} className='ml-[6px]' /></a>
                    </div>

                    {/* Important Note */}
                    <div className='bg-[#FE9D0B0F] border border-[#DAE4EE] rounded-[10px] px-[15px] py-[12px]'>
                        <LanguageTranslator tag='h4' className='text-[#92400E] text-[14px] font-bold mb-[10px]'>Important Note:</LanguageTranslator>
                        
                            <ul className='list-disc pl-5 marker:text-[#92400E] marker:text-[12px]'>
                                <li>
                                    <p className='text-[#333] text-[12px] font-normal leading-[1.6] mb-[5px]'>
                                        For any new requirement or concern, please <span className='font-semibold'>avoid using WhatsApp</span> for communication. Kindly raise your requests via <a href='mailto:support@supplymint.com' target='_blank' rel="noreferrer" className='text-[#5256E2] no-underline font-semibold hover:underline'>support@supplymint.com</a> to ensure proper tracking and faster resolution.
                                    </p>
                                </li>
                                <li>
                                    <p className='text-[#333] text-[12px] font-normal leading-[1.6] m-0'>
                                        Additionally, please raise all requirements and critical concerns <span className='font-semibold'>during weekdays (Monday to Friday)</span> and avoid raising any new requirements over the weekends, as technical teams are unavailable during that period.
                                    </p>
                                </li>
                            </ul>
                    </div>
                </>
            }
        </div>

    </div>
    )
}

export default EscalationMatrixModal